import React from "react";
import { Input, InputGroup, InputGroupText, Row } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const OrganisationSearchBar = function (props) {
  return (
    <div>
      <Row className="p-2 m-0">
        <InputGroup
          style={{ backgroundColor: "transparent" }}
          onBlur={(event) => {
            if (!event.currentTarget.contains(event.relatedTarget)) {
              props.setShowResultsField(false);
            }
          }}
        >
          <Input
            onClick={() => props.setShowResultsField(true)}
            onChange={(event) => {
              props.setSearchFilter(event.target.value);
            }}
            type="text"
            name="search"
            autoComplete="off"
            className={
              props.theme === "dark"
                ? "search-bar--searchinput search-bar--searchinput-dark"
                : "search-bar--searchinput search-bar--searchinput-light"
            }
            value={props.searchFilter !== "" ? props.searchFilter : ""}
            placeholder={props.placeHolder}
          />

          <InputGroupText
            className={
              props.theme === "dark"
                ? "search-bar--searchicon search-bar--searchicon-dark"
                : "search-bar--searchicon search-bar--searchicon-light"
            }
          >
            <FontAwesomeIcon icon="search"></FontAwesomeIcon>
          </InputGroupText>

          <ul
            className="search-bar--SearchList"
            hidden={!props.showResultsField}
          >
            {props.searchList()}
          </ul>
        </InputGroup>
      </Row>
    </div>
  );
};
export default OrganisationSearchBar;
